import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface HealthArea {
  id: string;
  name: string;
}

/** Names excluded from professional onboarding (e.g. patient-only area from DB). */
const EXCLUDED_FROM_PROFESSIONAL_ONBOARDING_NAMES = new Set(
  ["Paciente"].map((n) => n.toLowerCase()),
);

/** Health areas shown in professional /onboarding selects (backend may include non-professional rows). */
export function filterHealthAreasForProfessionalOnboarding(
  areas: HealthArea[],
): HealthArea[] {
  return areas.filter(
    (a) => !EXCLUDED_FROM_PROFESSIONAL_ONBOARDING_NAMES.has(a.name.trim().toLowerCase()),
  );
}

/** The `health_areas` row for end-user (patient) accounts — matched by display name. */
export function selectPatientHealthArea(
  areas: HealthArea[],
): HealthArea | undefined {
  return areas.find(
    (a) => a.name.trim().toLowerCase() === "paciente",
  );
}

const HEALTH_AREAS_QUERY_KEY = ["health-areas"] as const;

async function fetchHealthAreas(): Promise<HealthArea[]> {
  const { data, error } = await supabase
    .from("health_areas")
    .select("id, name")
    .eq("is_active", true)
    .order("display_order");

  if (error) throw error;
  return filterHealthAreasForProfessionalOnboarding(data ?? []);
}

export function useHealthAreas() {
  return useQuery({
    queryKey: HEALTH_AREAS_QUERY_KEY,
    queryFn: fetchHealthAreas,
    staleTime: 5 * 60 * 1000,
  });
}


